// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".zoom-meeting-embedded button{margin-top:20px;background-color:#2d8cff;color:#fff;text-decoration:none;padding-top:10px;padding-bottom:10px;padding-left:40px;padding-right:40px;display:inline-block;border-radius:10px;cursor:pointer;border:none;outline:none}.zoom-meeting-embedded button:hover{background-color:#2681f2}#content_container{max-width:100%}", ""]);
// Exports
module.exports = exports;
